module.exports = __webpack_public_path__ + "static/media/blockchain.e6a45163.svg";